import React from 'react';
import _, { map, isEmpty } from 'lodash';
import { Tag, Popover, Typography } from 'antd';
import classNames from 'classnames'
import { CellRenderers } from "utils/tableUtils";
import { ExpolitedIconV2 } from 'components/Icons';

export const CVE = (values = [], className = "", maxWidth=200, exploitedVulnerabilities,iconClassName = "font-size-md" ,findingId) => {
    if (isEmpty(values)) {
        return CellRenderers.VALUE_OR_NA();
    }
    if (typeof values === "string") {
        values = [values];
    }
    const resorces = values.slice();
    const minResources = resorces.splice(0, 1);
    let content = null;
    const exploitedVulArr = _.split(exploitedVulnerabilities, ",");
    const DisplayExploitedIcon = (cve) => exploitedVulArr.includes(cve) ? <ExpolitedIconV2 className={iconClassName}/> : null;
    if (resorces.length) {
        content = (
            <div style={{ maxHeight: 150, maxWidth: 200, overflow: "auto" }}>
                {
                    map(values, (text, i) => isEmpty(text) ? CellRenderers.VALUE_OR_NA() :
                    <Tag style={{ marginRight: 2, marginBottom: 2 }} className={classNames(className)} key={`${text}-${i}`} icon={DisplayExploitedIcon(text)}>
                        <a rel="noopener noreferrer" target="_blank"  href={`/compliance/vulnerability-rules/${text}/redirect?findingId=${findingId}`}>{text}</a>
                    </Tag>)
                }
            </div>
        )
    }
    return (
        <div>
            {
                map(minResources, (text, i) => isEmpty(text) ? CellRenderers.VALUE_OR_NA() :
                    <a rel="noopener noreferrer" target="_blank"  href={`/compliance/vulnerability-rules/${text}/redirect?findingId=${findingId}`} style={{ verticalAlign: 'middle', display: 'inline-block' }} key={`${text}-${i}`}>
                        <Tag icon={DisplayExploitedIcon(text)} title={text} className={classNames("text-ellipsis tools", className)} style={{ marginRight: 2, verticalAlign: 'inherit', maxWidth, fontSize: 13 }}>{text}</Tag>
                    </a>)
            }
            {
                resorces.length
                    ?
                    <Popover trigger="click" content={content}>
                        <Typography.Link className='p-l-0' style={{ fontSize: 12, verticalAlign: "middle" }}>+{resorces.length}</Typography.Link>
                    </Popover>
                    :
                    null
            }
        </div>
    )
}